import { useEffect } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Footer } from "@/components/landing/Footer";
import { PilotHero } from "@/components/pilot/PilotHero";
import { PilotIntroduction } from "@/components/pilot/PilotIntroduction";
import { WhoWeAreLookingFor } from "@/components/pilot/WhoWeAreLookingFor";
import { PilotObjectives } from "@/components/pilot/PilotObjectives";
import { PilotProcess } from "@/components/pilot/PilotProcess";
import { PilotApplicationForm } from "@/components/pilot/PilotApplicationForm";

export default function Pilot() {
  useEffect(() => {
    window.lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="pilot-page" className="bg-baseLight min-h-screen">
      <Navbar />
      <PilotHero />
      <PilotIntroduction />
      <WhoWeAreLookingFor />
      <PilotObjectives />
      <PilotProcess />
      <PilotApplicationForm />
      <Footer />
    </div>
  );
}
